import { Component, OnInit, Input, Output, EventEmitter, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwapModalComponent } from 'app/shared/swap-modal/swap-modal.component';
import { WorkplanService } from 'app/workplan/services/workplan.service';
import { MatDialog } from '@angular/material/dialog';
import { Workplan } from 'app/model';

@Component({
    selector: 'app-swap-button',
    templateUrl: './swap-button.component.html',
    styleUrls: ['./swap-button.component.scss'],
    standalone: true
})
export class SwapButtonComponent implements OnInit {
  @Input() idWorkplan: any;

  @Output() readOnlyEvent = new EventEmitter();

  workplan: Workplan;

  constructor(
    private workplanService: WorkplanService,
    public dialog: MatDialog,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit() {
  }

  onOpenSwapModal() {
    this.workplanService.getWorkplan(this.idWorkplan)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        workplan => {
          this.workplan = workplan;

          const dialogRef = this.dialog.open(SwapModalComponent, {
            width: '850px',
            data: {
              assemblyOrders: this.workplan.assemblyOrders,
              workplanName: this.workplan.name,
              idWorkplan: this.workplan.id
            }
          });

          dialogRef.componentInstance.cancelAction.subscribe(() => {
            dialogRef.close();
          });
        }
      );
  }
}
